import { Injectable } from '@angular/core';
import { AuthInfo } from '../../authorization/models';

@Injectable({ providedIn: 'root' })
export class CookieAuthService {
  private readonly cookieName = 'xemex_auth';
  private readonly cookieDomain = '.xemex-cloud.eu';

  writeCookie(authInfo: AuthInfo): void {
    const payload = JSON.stringify({
      access_token: authInfo.access_token,
      expires_on: authInfo.expires_on,
    });
    const expiresStr =
      authInfo.expires_on != null && authInfo.expires_on !== 0
        ? `; expires=${new Date(authInfo.expires_on * 1000).toUTCString()}`
        : '';
    document.cookie =
      `${this.cookieName}=${encodeURIComponent(payload)}` +
      `; domain=${this.cookieDomain}; path=/; Secure; SameSite=Lax${expiresStr}`;
  }

  clearCookie(): void {
    document.cookie =
      `${this.cookieName}=` +
      `; domain=${this.cookieDomain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Lax`;
  }
}
